module.exports = __webpack_public_path__ + "static/media/Доклад на одитния комитет.c90f6800.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Доклад на одитния комитет.pdf
// module id = 114
// module chunks = 0